export const Colors = {
    background: '#FFFFFF',
    secondaryBackground: '#EEF2F3',
    tertiaryBackground: '#0A213F',
    text: '#162948',
    secondaryText: '#FAFBFD',
    grey: '#FBFBFB',
    blue: '#2F69FE',
    red: '#E12E2E',
    lightBlue: '#8BB2FB',
    backgroundImage: 'linear-gradient(to right bottom, #3e5b89, #3a5683, #36527e, #334d78, #2f4973, #2f4973, #2f4973, #2f4973, #334d78, #36527e, #3a5683, #3e5b89)'
}